// src/routes/index.js
import {React, useEffect} from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/contact";
import Services from "../pages/Services";
import ScrollToTopButton from "../components/ScrollToTopButton";
import HerbalRemedies from "../components/services/HerbalRemedies";
import ShirodharaTreatment from "../components/services/ShirodharaTreatment";
import PanchakarmaTherapy from "../components/services/PanchakarmaTherapy";
import DetoxRejuvenation from "../components/services/DetoxRejuvenation";
import AbhyangaMassage from "../components/services/AbhyangaMassage";
import HolisticHealing from "../components/services/HolisticHealing";
import AdminLayout from "../pages/admin/admin_layout";
import AdminSettings from "../pages/admin/admin_settings";
import Retreats from "../pages/Retreats"
import CardiologyPreventive from "../components/retreats/CardiologyPreventive";
import NeurologyRetreat from "../components/retreats/NeurologyRetreat";
import InflammatoryAutoimmuneRetreat from "../components/retreats/InflammatoryAutoimmuneRetreat";
import LifestyleDisordersRetreat from "../components/retreats/LifestyleDisordersRetreat";
import NCDManagementRetreat from "../components/retreats/NCDManagementRetreat";
import OncologySupportiveCare from "../components/retreats/OncologySupportiveCare";
import PainManagementRetreat from "../components/retreats/PainManagementRetreat";
import BookNow from "../pages/BookNow";
import AdminBookings from "../pages/admin/AdminBookings";
import SplashScreen from '../components/SplashScreen';
import Facilities from '../pages/Facilities';

const AppRoutes = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
    
      <Routes>
        <Route path="/splash" element={<SplashScreen />} />
        {/* Home route */}
        <Route path="/" element={<Home />} />

        {/* Optional: scroll to sections */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        {/* Optional: Keep individual URLs for direct linking (recommended) */}
        <Route path="/services/herbal-remedies" element={<HerbalRemedies />} />
        <Route path="/services/shirodhara" element={<ShirodharaTreatment />} />
        <Route path="/services/panchakarma" element={<PanchakarmaTherapy />} />
        <Route path="/services/detox" element={<DetoxRejuvenation />} />
        <Route path="/services/abhyanga" element={<AbhyangaMassage />} />
        <Route path="/services/holistic-healing" element={<HolisticHealing />} />

        <Route path="/retreats" element={<Retreats />} />
        <Route path="/retreats/cardiology-preventive" element={ <CardiologyPreventive />} />        
        <Route path="/retreats/neurology-retreat" element={<NeurologyRetreat />} />
        <Route path="/retreats/inflammatory-autoimmune" element={<InflammatoryAutoimmuneRetreat />} />
        <Route path="/retreats/lifestyle-disorders" element={<LifestyleDisordersRetreat />} />
        <Route path="/retreats/non-communicable-diseases" element={<NCDManagementRetreat />} />
        <Route path="/retreats/oncology-supportive-care" element={<OncologySupportiveCare />} />
        <Route path="/retreats/pain-management" element={<PainManagementRetreat />} />

    <Route path="/facilities" element={<Facilities />} />
        <Route path="/admin" element={<AdminLayout />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/BookNow" element={<BookNow />} />

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Scroll to top button */}
      <ScrollToTopButton />
      
    </>
  );
};

export default AppRoutes;
